import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-included-item.reducer';

export const ActivityIncludedItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityIncludedItemEntity = useAppSelector(state => state.activityIncludedItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityIncludedItemDetailsHeading">
          <Translate contentKey="activitiesApp.activityIncludedItem.detail.title">ActivityIncludedItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityIncludedItemEntity.id}</dd>
          <dt>
            <span id="itemDetails">
              <Translate contentKey="activitiesApp.activityIncludedItem.itemDetails">Item Details</Translate>
            </span>
          </dt>
          <dd>{activityIncludedItemEntity.itemDetails}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityIncludedItem.activity">Activity</Translate>
          </dt>
          <dd>{activityIncludedItemEntity.activity ? activityIncludedItemEntity.activity.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-included-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-included-item/${activityIncludedItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityIncludedItemDetail;
